import { render, staticRenderFns } from "./PolicyPage.vue?vue&type=template&id=689f3197&scoped=true"
import script from "./PolicyPage.vue?vue&type=script&lang=ts"
export * from "./PolicyPage.vue?vue&type=script&lang=ts"
import style0 from "./PolicyPage.vue?vue&type=style&index=0&id=689f3197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689f3197",
  null
  
)

export default component.exports